export default {
    name: "eCash",
    coin: "XEC",
    scheme: "SOLO",
    account: 'qrtmcfv2r6p7t63v30ta4wwpkm4vxh399qtu9gkzrh',
    url: 'https://explorer.e.cash',
    explorer_url: 'https://explorer.e.cash',
    coingecko: 'https://www.coingecko.com/en/coins/ecash',
    explorer: {
        address: 'https://explorer.e.cash/address/',
        height: 'https://explorer.e.cash/block/',
        hash: 'https://explorer.e.cash/block/',
        tx: 'https://explorer.e.cash/tx/',
    },
    ports: [
        {
            info: 'LOW',
            host: 'molepool.com',
            port: 9601,
            diff: 65536,
        },
        {
            info: 'MID',
            host: 'molepool.com',
            port: 9602,
            diff: 1048576,
        }
    ]
};